import { render, staticRenderFns } from "./FormYoutubeField.vue?vue&type=template&id=acc086be&"
import script from "./FormYoutubeField.vue?vue&type=script&lang=js&"
export * from "./FormYoutubeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports